import { render, staticRenderFns } from "./alert-info.vue?vue&type=template&id=66e74d4b"
import script from "./alert-info.vue?vue&type=script&lang=js"
export * from "./alert-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports